import { useGiftCardInfoQuery } from '../../graphql/GiftCardInfo.generated';

export const useGiftCardBalance = () => {
  const [{ data, fetching }] = useGiftCardInfoQuery({
    requestPolicy: 'network-only',
  });

  const giftCardBalance =
    data?.giftCardBalance?.__typename === 'GiftCardBalance'
      ? data.giftCardBalance.giftCardBalance
      : 0;

  return {
    giftCardBalance,
    isFetchingGiftCardBalance: fetching,
  };
};
